import React, { useState, useEffect } from "react";
import { FiX, FiSave } from "react-icons/fi";
import axios from "axios";

const ModalAdicionarObra = ({ onClose, onSuccess }) => {
  const [projetos, setProjetos] = useState([]);
  const [formData, setFormData] = useState({
    id_projeto: "",
    latitude: "",
    longitude: "",
  });
  const [loading, setLoading] = useState(false);

  // Carrega lista de projetos
  useEffect(() => {
    // Nota: A rota lista-simples geralmente é pública ou precisa de token dependendo do seu backend.
    // Se der erro aqui também, adicione o header igual fizemos abaixo.
    const token = localStorage.getItem("Token");

    axios
      .get("/api/coordenadas/lista-simples", {
        headers: { Authorization: `Bearer ${token}` }, // Adicionei por garantia
      })
      .then((res) => {
        if (Array.isArray(res.data)) {
          setProjetos(res.data);
        } else if (res.data && Array.isArray(res.data.Result)) {
          setProjetos(res.data.Result);
        } else {
          setProjetos([]);
        }
      })
      .catch((err) => {
        console.error("Erro ao carregar projetos", err);
        setProjetos([]);
      });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      id_projeto: formData.id_projeto,
      latitude: parseFloat(formData.latitude),
      longitude: parseFloat(formData.longitude),
    };

    // --- CORREÇÃO PRINCIPAL AQUI ---
    const token = localStorage.getItem("Token"); // 1. Pega o token salvo

    axios
      .post("/api/coordenadas", payload, {
        headers: { Authorization: `Bearer ${token}` }, // 2. Envia no cabeçalho
      })
      .then(() => {
        alert("Obra adicionada ao mapa com sucesso!");
        if (onSuccess) onSuccess();
        onClose();
      })
      .catch((err) => {
        // Log para ajudar a entender se ainda der erro
        console.error("Erro no envio:", err.response ? err.response.data : err);

        if (err.response && err.response.status === 403) {
          alert("Erro de permissão: Você precisa estar logado.");
        } else {
          alert("Erro ao adicionar obra. Verifique os dados.");
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="map-modal-overlay">
      <div className="map-modal-content">
        <div className="map-modal-header">
          <h3>Adicionar Nova Obra</h3>
          <button onClick={onClose} className="btn-close-modal">
            <FiX />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="map-form">
          <div className="form-group">
            <label>Selecione o Projeto</label>
            <select
              name="id_projeto"
              value={formData.id_projeto}
              onChange={handleChange}
              required
              className="form-input"
            >
              <option value="">Selecione...</option>
              {Array.isArray(projetos) && projetos.length > 0 ? (
                projetos.map((proj) => (
                  <option key={proj.id} value={proj.id}>
                    {proj.nomeprojeto}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  Carregando projetos...
                </option>
              )}
            </select>
          </div>

          <div className="form-row">
            <div className="form-group half">
              <label>Latitude</label>
              <input
                type="text"
                name="latitude"
                placeholder="Ex: -22.8164"
                value={formData.latitude}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
            <div className="form-group half">
              <label>Longitude</label>
              <input
                type="text"
                name="longitude"
                placeholder="Ex: -45.1933"
                value={formData.longitude}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onClose} className="btn-cancel">
              Cancelar
            </button>
            <button type="submit" className="btn-save" disabled={loading}>
              <FiSave style={{ marginRight: "5px" }} />
              {loading ? "Salvando..." : "Adicionar no Mapa"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalAdicionarObra;
